const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    fill: "#554494",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -952.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 969.36c-1.145-5e-3 -1.9948 1.012-2 2v52c1.1e-4 1.0472 0.95283 1.9999 2 2h51.156c2.3812 5.8552 8.1503 10 14.844 10 8.8129 0 16-7.1871 16-16 0-6.6935-4.1448-12.462-10-14.844v-33.156c-1e-4 -1.0472-0.95283-1.9999-2-2zm2 4h66v30.156c-0.65894-0.083-1.3191-0.1562-2-0.1562-8.8129 0-16 7.1871-16 16 0 0.6809 0.073 1.3411 0.15625 2h-48.156zm24.031 12v24c-8e-3 1.4253 1.7475 2.4898 2.9375 1.7812l20-12c1.2141-0.70295 1.2141-2.8596 0-3.5625l-20-12c-1.3826-0.60154-2.9057 0.60775-2.9375 1.7812zm3.9375 3.5312 14.094 8.4688-14.094 8.4687zm36.031 18.469c6.6511 0 12 5.3489 12 12s-5.3489 12-12 12-12-5.3489-12-12 5.3489-12 12-12zm0 3c-0.57711 0-1.0724 0.2654-1.4375 0.6562-1.6356 1.5138-3.3418 3.3005-4.9688 4.9375-0.79674 0.8045-0.78114 2.0315 0 2.8125 0.78114 0.7811 2.0314 0.7811 2.8125 0l1.5938-1.5937v9.1875c0 1.1046 0.8953 2 2 2s2-0.8954 2-2v-9.1875l1.5938 1.5937c0.78112 0.7811 2.0314 0.7811 2.8125 0 0.78114-0.781 0.80455-2.008 0-2.8125-1.6623-1.6011-3.3039-3.4538-4.9688-4.9375-0.36507-0.3908-0.86039-0.6562-1.4375-0.6562z",
    color: "#554494",
    overflow: "visible",
    style: {
      blockProgression: "tb",
      textIndent: 0,
      textTransform: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.4956f654d22ff5662b1a1ac037de5c8b.svg";
export { ForwardRef as ReactComponent };